module.exports = "https://web-assets.ifttt.com/packs/media/ifttt_next/pro-upsell-story-75aaec42.svg";